(async function () {
  'use strict';

  const PARAM = 'pin';
  const GRID_VIEW = 'grid-item';
  const LOOP_SELECTOR = '#AjaxinateLoop';
  const CARD_SELECTOR = '.product-grid-item';

  const qs = new URLSearchParams(location.search);
  const pinRaw = qs.get(PARAM);
  if (!pinRaw) return;
  const loop = document.querySelector(LOOP_SELECTOR);
  if (!loop) return;

  /** ============ 工具函数 ============ **/
  const splitList = (str) =>
    String(str)
      .split(/[|,]/g)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((s) => s.replace(/\+/g, '%20'))
      .map((s) => {
        try {
          return decodeURIComponent(s);
        } catch {
          return s;
        }
      });

  const normalizeTitle = (s) => String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');

  const extractHandleFromHref = (href) => {
    if (!href) return '';
    const m = String(href).match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : '';
  };

  const getHandleFromCardElement = (el) => {
    if (!el) return '';
    if (el.dataset?.pinHandle) return el.dataset.pinHandle;
    const a = el.querySelector('a[data-grid-link]') || el.querySelector('a[href*="/products/"]');
    return extractHandleFromHref(a?.getAttribute('href'));
  };

  const resolveHandleFromDomById = (productId) => {
    const pid = String(productId).trim();
    if (!pid) return '';
    const cards = Array.from(loop.querySelectorAll(CARD_SELECTOR));
    for (const el of cards) {
      const idAttr = el.getAttribute('id') || '';
      if (idAttr.includes(`--${pid}--`)) {
        const h = getHandleFromCardElement(el);
        if (h) return h;
      }
    }
    return '';
  };

  /** ============ 反查接口 ============ **/
async function resolveHandleBySuggest(query, preferTitleExact, pickIndex = 1) {
  const q = String(query || '').trim();
  if (!q) return '';
  const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=last`;
  const r = await fetch(url, { credentials: 'same-origin' });
  if (!r.ok) return '';
  const data = await r.json().catch(() => null);
  const products = data?.resources?.results?.products;
  if (!Array.isArray(products) || !products.length) return '';

  if (preferTitleExact) {
    const want = normalizeTitle(q);
    const exactList = products.filter((p) => normalizeTitle(p.title) === want);
    const target = exactList[pickIndex - 1];
    if (target?.handle) return target.handle;
  }

  // fallback: 按顺序取第 pickIndex 个
  const target = products[pickIndex - 1];
  return target?.handle || '';
}


  // ✅ 关键：通过 /products/{id}.js 精准反查 handle
  async function resolveHandleByProductJson(id) {
    try {
      const r = await fetch(`/products/${id}.js`, { credentials: 'same-origin' });
      if (!r.ok) {
        console.warn(`❌ /products/${id}.js returned ${r.status}`);
        return '';
      }
      const j = await r.json();
      return j?.handle || '';
    } catch (err) {
      console.warn(`⚠️ /products/${id}.js 请求失败`, err);
      return '';
    }
  }

  // 兜底：某些店铺可能拦截 .js，可用 collections 搜索反查
  async function resolveHandleByCollectionFallback(id) {
    try {
      const html = await fetch(`/collections/all?q=${id}`).then((r) => r.text());
      const m = html.match(/\/products\/([a-z0-9\-]+)["']/i);
      return m ? m[1] : '';
    } catch {
      return '';
    }
  }

const parsePinToken = (token) => {
  const t = String(token || '').trim();
  if (!t) return null;

  // 支持 #n 选择器，如 title:xxx#2 或 id:123#3
  const m = t.match(/^(title|id|handle)?:?([^#]+)(?:#(\d+))?$/i);
  if (m) {
    const type = (m[1] || '').toLowerCase() || (/^\d+$/.test(m[2]) ? 'id' : 'handle');
    const value = m[2].trim();
    const index = parseInt(m[3] || '1', 10);
    return { type, value, index };
  }

  // 无类型标签但纯数字
  if (/^\d+$/.test(t)) return { type: 'id', value: t, index: 1 };
  return { type: 'handle', value: t, index: 1 };
};

  /** ============ 统一解析器 ============ **/
 async function resolveToHandle(spec) {
  if (!spec) return '';
  if (spec.type === 'handle') return spec.value;

  if (spec.type === 'id') {
    const dom = resolveHandleFromDomById(spec.value);
    if (dom) return dom;
    const s1 = await resolveHandleBySuggest(spec.value, false, spec.index);
    if (s1) return s1;
    const s2 = await resolveHandleByProductJson(spec.value);
    if (s2) return s2;
    const s3 = await resolveHandleByCollectionFallback(spec.value);
    if (s3) return s3;
    return '';
  }

  if (spec.type === 'title') {
    const s = await resolveHandleBySuggest(spec.value, true, spec.index);
    return s || '';
  }

  return '';
}

  /** ============ 拉取卡片渲染 ============ **/
  async function fetchGridCardHtml(handle) {
    const url = `/products/${encodeURIComponent(handle)}?view=${encodeURIComponent(GRID_VIEW)}`;
    const r = await fetch(url, { credentials: 'same-origin' });
    if (!r.ok) throw new Error(`grid-item HTTP ${r.status}`);
    return await r.text();
  }

  const pickCardFromHtml = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.querySelector(CARD_SELECTOR);
  };

  const insertAfterNode = (parent, node, after) => parent.insertBefore(node, after.nextSibling);

  /** ============ 主逻辑 ============ **/
  const tokens = splitList(pinRaw).map(parsePinToken).filter(Boolean);
  console.group('TOM URL Pin Injector v17 — Smart Resolver');
  console.log('Raw pin:', pinRaw);
  console.log('Parsed tokens:', tokens);

  const marker = document.createComment('tom-pin-marker');
  loop.insertBefore(marker, loop.firstChild);
  let cursor = marker;
  const insertedHandles = new Set();

  for (const spec of tokens) {
    try {
      const handle = await resolveToHandle(spec);
      if (!handle) {
        console.warn('⚠️ Could not resolve handle:', spec);
        continue;
      }

      if (insertedHandles.has(handle)) continue;
      console.log(`→ [${spec.type}] ${spec.value} => ${handle}`);

      const html = await fetchGridCardHtml(handle);
      const card = pickCardFromHtml(html);
      if (!card) continue;

      card.classList.add('pinned-product');
      card.dataset.pinHandle = handle;

      insertAfterNode(loop, card, cursor);
      cursor = card;

      insertedHandles.add(handle);
      console.log('✅ Inserted pinned:', handle);
    } catch (e) {
      console.error('❌ Insert failed:', spec, e);
    }
  }

  if (insertedHandles.size)
    console.log('🎯 Total pinned inserted:', insertedHandles.size, Array.from(insertedHandles));
  else console.warn('⚠️ No pinned products inserted');

  /** ============ 自动去重 ============ **/
  const mo = new MutationObserver(() => {
    const cards = Array.from(loop.querySelectorAll(CARD_SELECTOR));
    for (const el of cards) {
      if (!el || el.classList.contains('pinned-product')) continue;
      const h = getHandleFromCardElement(el);
      if (h && insertedHandles.has(h)) {
        el.remove();
        console.log('🧹 Removed duplicate:', h);
      }
    }
  });
  mo.observe(loop, { childList: true, subtree: false });

  console.groupEnd();
})();
